import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CuadroDialogoComponent } from 'app/componentes/cuadro-dialogo/cuadro-dialogo.component';
import { CertificadoService } from 'app/services/certificaciones/certificados.services';

@Component({
  selector: 'app-certificados',
  templateUrl: './certificados.component.html',
  styleUrls: ['./certificados.component.scss']
})
export class CertificadosComponent implements OnInit {

  displayedColumns: string[] = ['orden','nombre', 'estado', 'ver', 'delete'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;

  public datos_nosotros: any = [];

  constructor(private serviceNosotros: CertificadoService, 
    private dialog: MatDialog, 
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.obtenerDatos()
  }

  obtenerDatos = () =>{
    this.serviceNosotros.getCertificados().subscribe(response =>{
      this.datos_nosotros = response;
      this.dataSource = new MatTableDataSource(this.datos_nosotros)
      this.dataSource.sort = this.sort;
    })
  }
  

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  eliminarDato = (id) => {
    this.dialog.open(CuadroDialogoComponent).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.serviceNosotros.eliminarCertficado(id).subscribe(response =>{
          this.obtenerDatos()
        })
      }
  
    })
  }

  //AVISO TIPO SNACKBAR ANGULAR MATERIAL
  openSnackBar(message: string) {
    this.snackBar.open(message, "Aceptar", { duration: 2000 });
  }


  drop(event: CdkDragDrop<string[]>) {
    let i = 1;
    moveItemInArray(this.datos_nosotros, event.previousIndex, event.currentIndex);
    this.dataSource = new MatTableDataSource(this.datos_nosotros);
    this.dataSource.sort = this.sort;
    this.datos_nosotros.reverse()
    this.datos_nosotros.forEach(certificado => {
      certificado.orden = i;

      if (certificado.estado == 'ACTIVO') {
        certificado.estado = 1;
      } else {
        certificado.estado = 0;
      }

      this.serviceNosotros.actualizarCertficado(certificado.idCertificacion, certificado).subscribe(response => {
      });


      if (certificado.estado == 1) {
        certificado.estado = 'ACTIVO';
      } else {
        certificado.estado = 'INACTIVO';
      }

      i++;
    });
    this.openSnackBar("EL REGISTRO SE MOVIO CORRECTAMENTE!")
    this.datos_nosotros.reverse()
    // this.obtenerDatos()
  }

}
